import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  AxisZArrow,
} from 'mdi-material-ui';

import {
  GridItem,
  GridContainer,
  CustomTabs,
} from '../../generic';

import {
  GroupFTPExportIntegrationEditCard,
  GroupDeltaCloudExportIntegrationEditCard,
} from '../components';

const GroupExportIntegrationsTab = (props) => {
  const { group, canEdit } = props;
  const { t } = useTranslation('translations');

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          headerColor="rose"
          tabs={[
            {
              tabName: t('exportIntegrations.ftp.title'),
              tabIcon: AxisZArrow,
              tabContent: (
                <GroupFTPExportIntegrationEditCard
                  canEdit={canEdit}
                  group={group}
                />
              ),
            },
            {
              tabName: t('exportIntegrations.deltaCloud.title'),
              tabIcon: AxisZArrow,
              tabContent: (
                <GroupDeltaCloudExportIntegrationEditCard
                  canEdit={canEdit}
                  group={group}
                />
              ),
            },
          ]}
        />
      </GridItem>
    </GridContainer>
  );
};

const propTypes = {
  // eslint-disable-next-line react/require-default-props, react/forbid-prop-types
  group: PropTypes.object,
  // group: PropTypes.shape({
  //   id: PropTypes.string,
  //   name: PropTypes.string,
  // }).isRequired,
  canEdit: PropTypes.bool.isRequired,
};

GroupExportIntegrationsTab.propTypes = propTypes;

export default GroupExportIntegrationsTab;
